import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getDatabase, ref, onValue , get} from "firebase/database";
import Navbar1 from "./Navbar";
import {
  FaMapMarkerAlt,
  FaTimes,
  FaStar,
  FaPlane,
  FaBus,
  FaHotel,
  FaUtensils,
  FaMonument,
  FaCalendarAlt,
  FaFilePdf,
} from "react-icons/fa";
import { FiChevronRight } from "react-icons/fi";
import Footer1 from "./Footer";
import { jsPDF } from "jspdf";
import logo from "../../assets/logo.png";

const DeparturePage = () => {
  const [tours, setTours] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedTour, setSelectedTour] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const modalRef = useRef(null);
  const [tourPackages, setTourPackages] = useState([]);
  const packagesRef = ref(getDatabase(), "AgentPackages");

  // Utility function to extract numbers from strings
  const extractNumbers = (str) => {
    if (!str) return 0;
    const numbers = str.toString().match(/\d+\.?\d*/g);
    return numbers ? parseFloat(numbers.join("")) : 0;
  };




useEffect(() => {
  const database = getDatabase();
  const packagesRef = ref(database, "AgentPackages");

  const unsubscribe = onValue(
    packagesRef,
    (snapshot) => {
      try {
        const data = snapshot.val();
        if (!data) {
          console.log("No data found at AgentPackages");
          setTours([]);
          setLoading(false);
          return;
        }

        let allPackages = [];

        ["international", "domestic"].forEach((packageType) => {
          if (data[packageType]) {
            const countries = data[packageType];

            Object.keys(countries).forEach((country) => {
              const countryPackages = countries[country];

              if (countryPackages) {
                Object.keys(countryPackages).forEach((packageKey) => {
                  const pkg = countryPackages[packageKey];

                  if (pkg) {
                    let parsedItinerary = [];
                    if (pkg.itinerary) {
                      parsedItinerary =
                        typeof pkg.itinerary === "object"
                          ? Object.values(pkg.itinerary)
                          : [];
                    }

                    let images = [];
                    if (pkg.images) {
                      images = Array.isArray(pkg.images)
                        ? pkg.images
                        : Object.values(pkg.images);
                    }

                    // Extract and process the first price from priceValues
                    let firstPriceValue = "";
                    let priceText = "";
                    
                    // Get the first price value from different possible structures
                    if (pkg.priceValues) {
                      // If it's an array, get first element
                      if (Array.isArray(pkg.priceValues)) {
                        priceText = pkg.priceValues[0] || "";
                      } 
                      // If it's an object, get first value
                      else if (typeof pkg.priceValues === "object") {
                        const values = Object.values(pkg.priceValues);
                        priceText = values.length > 0 ? values[0] : "";
                      } 
                      // If it's already a string
                      else if (typeof pkg.priceValues === "string") {
                        priceText = pkg.priceValues;
                      }
                      
                      // Clean and extract just the first price
                      if (priceText) {
                        // Look for price patterns like "49,900 /-*" or "Total Price (INR): 49,900 /-*"
                        // This will match numbers with optional commas and optional decimal points
                        const priceMatch = priceText.match(/(\d[\d,]*\.?\d*)(?=\s*\/|\s*\*|\s*$|\s*\()/);
                        if (priceMatch) {
                          firstPriceValue = priceMatch[1];
                          // Remove all non-digit characters and convert to number
                          firstPriceValue = parseInt(firstPriceValue.replace(/[^0-9]/g, ''), 10) || 0;
                        } else {
                          // Fallback: try to find any number in the text
                          const fallbackMatch = priceText.match(/(\d[\d,]*\.?\d*)/);
                          if (fallbackMatch) {
                            firstPriceValue = parseInt(fallbackMatch[0].replace(/[^0-9]/g, ''), 10) || 0;
                          }
                        }
                      }
                    }

                    // Use the extracted price value
                    const numericPrice = firstPriceValue || 0;

                    // Store the original price and apply discount only once
                    const formattedPackage = {
                      id: pkg.id || packageKey,
                      name: pkg.name || "Unnamed Package",
                      packageId: pkg.packageId || packageKey,
                      destination: pkg.destination || country,
                      duration: pkg.duration || "Not specified",
                      description: pkg.description || "",
                      price: numericPrice, // Store original price here
                      originalPrice: numericPrice,
                      type: packageType,
                      includes: pkg.includes ? Object.values(pkg.includes) : [],
                      excludes: pkg.excludes ? Object.values(pkg.excludes) : [],
                      itinerary: parsedItinerary,
                      images: images,
                      image: images.length > 0 ? images[0] : null,
                      nights: parseInt(pkg.duration?.match(/\d+N/)?.[0]) || 4,
                      markupValue: pkg.markupValue || 0,
                      markupType: pkg.markupType || null,
                      markupStatus: pkg.markupStatus || null,
                      priceValues: pkg.priceValues || null,
                    };

                    allPackages.push(formattedPackage);
                  }
                });
              }
            });
          }
        });

        // Format tours with original pricing
        const formattedTours = allPackages.map((pkg, index) => {
          const originalPrice = pkg.originalPrice;
          const hasDiscount = false; // Remove automatic discount

          return {
            ...pkg,
            title: pkg.name,
            days: pkg.nights + 1,
            highlights:
              pkg.itinerary && pkg.itinerary.length > 0
                ? pkg.itinerary
                    .slice(0, 4)
                    .map((item) => (typeof item === "object" ? item.title : item))
                : [
                    `${pkg.destination} City Tour`,
                    `${pkg.destination} Local Market`,
                    `${pkg.destination} Cultural Show`,
                    `${pkg.destination} Historical Sites`,
                  ],
            bestSelling: index < 4,
            rating: 5,
            originalPrice: originalPrice,
            originalPriceFormatted: `₹${originalPrice.toLocaleString("en-IN")}`,
            discountedPrice: originalPrice, // No discount applied
            discountedPriceFormatted: `₹${originalPrice.toLocaleString("en-IN")}`,
            discountAmount: 0, // No automatic discount
            discountAmountFormatted: `₹0`,
            hasDiscount: false, // No automatic discount
            price: `₹${originalPrice.toLocaleString("en-IN")}`,
          };
        });

        setTours(formattedTours);
        setLoading(false);
      } catch (err) {
        console.error("Error processing packages:", err);
        setError("Failed to process package data");
        setLoading(false);
      }
    },
    (error) => {
      console.error("Firebase read error:", error);
      setError("Failed to connect to database");
      setLoading(false);
    }
  );

  return () => unsubscribe();
}, []);













  const handleDetailsClick = (tour) => {
    setSelectedTour(tour);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const generatePDF = () => {
    if (!selectedTour) return;

    // Helper function to extract numbers from strings
    const extractNumbers = (str) => {
      if (typeof str === "number") return str;
      const numMatch = str.toString().match(/\d+(\.\d+)?/g);
      if (numMatch) {
        const numStr = numMatch[0].replace(/,/g, "");
        return parseFloat(numStr);
      }
      return 0;
    };

    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });

    let yPosition = 20;

    // Header with company info
    doc.setFontSize(22);
    doc.setTextColor(30, 58, 138);
    doc.setFont("helvetica", "bold");
    doc.text("Pearl Tours & Travels", 105, yPosition, { align: "center" });
    yPosition += 10;

    doc.setFontSize(10);
    doc.setTextColor(100, 100, 100);
    doc.setFont("helvetica", "normal");
    doc.text(
      "Address: Pearl Enclave, MSEB Rd, next to Chai Sutta Bar,",
      105,
      yPosition,
      { align: "center" }
    );
    yPosition += 5;
    doc.text(
      "Viya Nagar, Vishrambag, Sangli, Maharashtra 416415",
      105,
      yPosition,
      { align: "center" }
    );
    yPosition += 5;
    doc.text(
      "Mobile: +91-73034 55505 | Email: pearltoursandtravelsangli@gmail.com",
      105,
      yPosition,
      { align: "center" }
    );
    yPosition += 15;

    // Title
    doc.setFontSize(16);
    doc.setTextColor(30, 58, 138);
    doc.setFont("helvetica", "bold");
    doc.text("TOUR PACKAGE DETAILS", 105, yPosition, { align: "center" });
    yPosition += 15;

    // Divider
    doc.setDrawColor(200, 200, 200);
    doc.setLineWidth(0.5);
    doc.line(20, yPosition, 190, yPosition);
    yPosition += 10;

    // Package name
    doc.setFontSize(18);
    doc.setTextColor(30, 58, 138);
    doc.setFont("helvetica", "bold");
    doc.text(`${selectedTour.title.toUpperCase()}`, 20, yPosition);
    yPosition += 10;

    // Package details
    doc.setFontSize(12);
    doc.setTextColor(80, 80, 80);
    doc.setFont("helvetica", "normal");
    doc.text(`Destination: ${selectedTour.destination}`, 20, yPosition);
    yPosition += 7;
    doc.text(`Duration: ${selectedTour.duration}`, 20, yPosition);
    yPosition += 7;

    // Price information - Show only the first price
    doc.setFontSize(12);
    doc.setTextColor(30, 58, 138);
    doc.setFont("helvetica", "bold");
    doc.text("PRICE DETAILS", 20, yPosition);
    yPosition += 7;

    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");

    if (selectedTour.priceValues) {
      let priceText = "";
      
      // Get the first price value from different possible structures
      if (Array.isArray(selectedTour.priceValues)) {
        priceText = selectedTour.priceValues[0] || "";
      } 
      else if (typeof selectedTour.priceValues === "object") {
        const values = Object.values(selectedTour.priceValues);
        priceText = values.length > 0 ? values[0] : "";
      } 
      else if (typeof selectedTour.priceValues === "string") {
        priceText = selectedTour.priceValues;
      }
      
      // Extract and format the first price
      if (priceText) {
        // Look for price patterns like "49,900 /-*" or "Total Price (INR): 49,900 /-*"
        const priceMatch = priceText.match(/(\d[\d,]*\.?\d*)(?=\s*\/|\s*\*|\s*$|\s*\()/);
        if (priceMatch) {
          const priceValue = priceMatch[1];
          doc.setTextColor(30, 58, 138);
          doc.setFont("helvetica", "bold");
          doc.text(`Package Price: ₹${priceValue}`, 20, yPosition);
          yPosition += 10;
        } else {
          // Fallback: try to find any number in the text
          const fallbackMatch = priceText.match(/(\d[\d,]*\.?\d*)/);
          if (fallbackMatch) {
            doc.setTextColor(30, 58, 138);
            doc.setFont("helvetica", "bold");
            doc.text(`Package Price: ₹${fallbackMatch[0]}`, 20, yPosition);
            yPosition += 10;
          }
        }
      }

      if (selectedTour.totalPrice) {
        // Display original total price
        doc.setFont("helvetica", "bold");
        doc.text(
          `Total Package Price: ${selectedTour.totalPrice}`,
          20,
          yPosition
        );

        // Show the original total price without modifications
        const formattedTotal = `₹${extractNumbers(selectedTour.totalPrice).toLocaleString("en-IN")}`;

        doc.setTextColor(30, 58, 138);
        doc.text(
          `Total Price: ${formattedTotal}`,
          20,
          yPosition + 8
        );

        yPosition += 16;
      }
    } else if (selectedTour.discountedPrice) {
      // Display the original price
      const formattedPrice = `₹${selectedTour.originalPrice.toLocaleString("en-IN")}`;
      doc.text(`Price: ${formattedPrice}`, 20, yPosition);

      yPosition += 16;
    } else {
      doc.text("No pricing information available", 20, yPosition);
      yPosition += 7;
    }

    yPosition += 10;

    // Description (unchanged from database)
    doc.setFontSize(14);
    doc.setTextColor(30, 58, 138);
    doc.setFont("helvetica", "bold");
    doc.text("DESCRIPTION", 20, yPosition);
    yPosition += 10;

    doc.setFontSize(12);
    doc.setTextColor(50, 50, 50);
    const descriptionLines = doc.splitTextToSize(
      selectedTour.description || "No description available",
      170
    );
    descriptionLines.forEach((line) => {
      if (yPosition > 267) {
        doc.addPage();
        yPosition = 20;
      }
      doc.text(line, 20, yPosition);
      yPosition += 6;
    });
    yPosition += 10;

    // Itinerary (unchanged from database)
    if (selectedTour.itinerary && selectedTour.itinerary.length > 0) {
      doc.addPage();
      yPosition = 20;
      doc.setFontSize(16);
      doc.setTextColor(30, 58, 138);
      doc.setFont("helvetica", "bold");
      doc.text("DETAILED ITINERARY", 105, yPosition, { align: "center" });
      yPosition += 10;

      selectedTour.itinerary.forEach((day, index) => {
        if (yPosition > 267) {
          doc.addPage();
          yPosition = 20;
        }

        doc.setFillColor(241, 243, 245);
        doc.rect(15, yPosition, 180, 8, "F");
        doc.setFontSize(14);
        doc.setTextColor(30, 58, 138);

        const dayTitle =
          typeof day === "object" ? day.title || "Day Activities" : day;
        doc.text(`Day ${index + 1}: ${dayTitle}`, 20, yPosition + 6);
        yPosition += 10;

        doc.setFontSize(12);
        doc.setTextColor(50, 50, 50);
        const descText =
          typeof day === "object"
            ? day.description || day.title || "No details provided"
            : day;
        const descLines = doc.splitTextToSize(descText, 170);
        descLines.forEach((line) => {
          if (yPosition > 267) {
            doc.addPage();
            yPosition = 20;
          }
          doc.text(line, 20, yPosition);
          yPosition += 6;
        });
        yPosition += 5;
      });
    }

    // Inclusions (unchanged from database)
    doc.addPage();
    yPosition = 20;
    doc.setFontSize(16);
    doc.setTextColor(30, 58, 138);
    doc.setFont("helvetica", "bold");
    doc.text("INCLUSIONS", 20, yPosition);
    yPosition += 10;

    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    if (selectedTour.includes && selectedTour.includes.length > 0) {
      selectedTour.includes.forEach((item) => {
        if (yPosition > 267) {
          doc.addPage();
          yPosition = 20;
        }
        doc.text(`• ${item}`, 25, yPosition);
        yPosition += 7;
      });
    } else {
      doc.text("No inclusions listed.", 25, yPosition);
      yPosition += 7;
    }

    // Exclusions (unchanged from database)
    yPosition += 10;
    doc.setFontSize(16);
    doc.setTextColor(30, 58, 138);
    doc.setFont("helvetica", "bold");
    doc.text("EXCLUSIONS", 20, yPosition);
    yPosition += 10;

    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    if (selectedTour.excludes && selectedTour.excludes.length > 0) {
      selectedTour.excludes.forEach((item) => {
        if (yPosition > 267) {
          doc.addPage();
          yPosition = 20;
        }
        doc.text(`• ${item}`, 25, yPosition);
        yPosition += 7;
      });
    } else {
      doc.text("No exclusions listed.", 25, yPosition);
      yPosition += 7;
    }

    // Footer
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(10);
      doc.setTextColor(100, 100, 100);
      doc.text(`Page ${i} of ${pageCount}`, 105, 287, { align: "center" });
      doc.text("Pearl Tours & Travels", 20, 287);
      doc.text(new Date().toLocaleDateString(), 190, 287, { align: "right" });
    }

    // Save the PDF
    const fileName = `${selectedTour.title.replace(/\s+/g, "_")}_details.pdf`;
    doc.save(fileName);
  };

  // if (loading) {
  //   return (
  //     <>
  //       <Navbar1 />
  //    <div>
  //     <style>{`
  //       .loading-container {
  //         position: fixed;
  //         top: 0;
  //         left: 0;
  //         width: 100vw;
  //         height: 100vh;
  //         display: flex;
  //         justify-content: center;
  //         align-items: center;
  //         background: linear-gradient(135deg, #7d0000ff 0%, #ab0404ff 100%);
  //         color: #fff;
  //         z-index: 9999;
  //         flex-direction: column;
  //       }

  //       .loader {
  //         display: flex;
  //         flex-direction: column;
  //         align-items: center;
  //         gap: 16px;
  //       }

  //       .loader-spinner {
  //         width: 80px;
  //         height: 80px;
  //         border: 8px solid rgba(255, 255, 255, 0.2);
  //         border-top: 8px solid #fff;
  //         border-radius: 50%;
  //         animation: spin 1.2s linear infinite;
  //       }

  //       .loader-spinner-inner {
  //         width: 40px;
  //         height: 40px;
  //         border: 4px solid rgba(255, 255, 255, 0.2);
  //         border-top: 4px solid #ffeb3b;
  //         border-radius: 50%;
  //         margin: auto;
  //         margin-top: 14px;
  //         animation: spin-reverse 1.5s linear infinite;
  //       }

  //       .loader-text {
  //         font-size: 1.4rem;
  //         font-weight: bold;
  //         letter-spacing: 1px;
  //         margin-top: 10px;
  //       }

  //       .loader-dots {
  //         display: flex;
  //         gap: 6px;
  //         margin-top: 5px;
  //       }

  //       .dot {
  //         width: 10px;
  //         height: 10px;
  //         background: #fff;
  //         border-radius: 50%;
  //         animation: bounce 1.2s infinite ease-in-out;
  //       }

  //       .dot:nth-child(1) {
  //         animation-delay: 0s;
  //       }

  //       .dot:nth-child(2) {
  //         animation-delay: 0.2s;
  //       }

  //       .dot:nth-child(3) {
  //         animation-delay: 0.4s;
  //       }

  //       @keyframes spin {
  //         0% { transform: rotate(0deg); }
  //         100% { transform: rotate(360deg); }
  //       }

  //       @keyframes spin-reverse {
  //         0% { transform: rotate(360deg); }
  //         100% { transform: rotate(0deg); }
  //       }

  //       @keyframes bounce {
  //         0%, 80%, 100% {
  //           transform: scale(0.8);
  //           opacity: 0.6;
  //         }
  //         40% {
  //           transform: scale(1.2);
  //           opacity: 1;
  //         }
  //       }
  //     `}</style>

  //     <div className="loading-container">
  //       <div className="loader">
  //         <div className="loader-spinner">
  //           <div className="loader-spinner-inner"></div>
  //         </div>
  //         <div className="loader-text">Loading Packages</div>
  //         <div className="loader-dots">
  //           <span className="dot"></span>
  //           <span className="dot"></span>
  //           <span className="dot"></span>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  //     </>
  //   );
  // }

if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          flexDirection: "column",
          background: "linear-gradient(135deg, #eb0e0eff 0%, #e9120eff 100%)",
        }}
      >
        {/* Logo with rotation and pulse animation */}
        <div
          style={{
            width: "100px",
            height: "100px",
            marginBottom: "25px",
            animation: "rotateAndPulse 2s infinite ease-in-out",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* Company logo image */}
          <img
            src={logo}
            style={{
              width: "80px",
              height: "80px",
              borderRadius: "50%",
              objectFit: "contain",
              boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
            }}
            alt="Company Logo"
          />
        </div>

        {/* Progress bar */}
        <div
          style={{
            width: "220px",
            height: "6px",
            backgroundColor: "rgba(255,255,255,0.3)",
            borderRadius: "3px",
            overflow: "hidden",
            marginBottom: "25px",
          }}
        >
          <div
            style={{
              width: "100%",
              height: "100%",
              backgroundColor: "white",
              borderRadius: "3px",
              animation: "progress 2s infinite ease-in-out",
            }}
          ></div>
        </div>

        <p
          style={{
            color: "white",
            fontSize: "18px",
            fontWeight: "500",
            textShadow: "0 2px 4px rgba(0,0,0,0.2)",
            marginBottom: "10px",
          }}
        >
          Loading packages...
        </p>

        <p
          style={{
            color: "rgba(255,255,255,0.8)",
            fontSize: "14px",
            fontStyle: "italic",
          }}
        >
          Almost there
        </p>

        <style>{`
    @keyframes rotateAndPulse {
      0% { transform: rotate(0deg) scale(1); }
      50% { transform: rotate(180deg) scale(1.1); }
      100% { transform: rotate(360deg) scale(1); }
    }
    @keyframes progress {
      0% { transform: translateX(-100%); }
      100% { transform: translateX(100%); }
    }
  `}</style>
      </div>
    );
  }



  if (error) {
    return (
      <>
        <Navbar1 />
        <div className="error-container">
          <p>⚠️ {error}</p>
          <button onClick={() => window.location.reload()}>Try Again</button>
        </div>
      </>
    );
  }

  return (
    <>
      <Navbar1 />
      <div className="departure-page">
        <header className="page-header">
          <div className="header-content">
            <h1>
              Upcoming <span>Departures</span>
            </h1>
            <p>
              Discover our curated selection of exclusive tours designed for
              unforgettable experiences
            </p>
            <div className="header-decoration">
              <div className="decoration-line"></div>
              <div className="decoration-dot"></div>
              <div className="decoration-line"></div>
            </div>
          </div>
        </header>

        <div className="tour-grid-container">
          <div className="tour-grid">
            {tours.map((tour) => (
              <div
                key={tour.id}
                className={`tour-card ${
                  tour.bestSelling ? "best-selling" : ""
                }`}
              >
                {tour.bestSelling && (
                  <div className="best-seller-badge">
                    <span>BEST SELLER</span>
                    <div className="badge-tail"></div>
                  </div>
                )}

                <div className="card-image-container">
                  <img
                    src={tour.image || "https://via.placeholder.com/400x300"}
                    alt={tour.name}
                  />
                  <div className="image-overlay">
                    <span className="tour-duration">
                      {tour.days} Days / {tour.nights} Nights
                    </span>
                    <div className="rating-badge">
                      <FaStar className="star-icon" />
                      <span>{tour.rating}</span>
                    </div>
                  </div>
                </div>

                <div className="card-content">
                  <div className="tour-header">
                    <h3>{tour.title}</h3>
                    <div className="tour-destination">
                      <FaMapMarkerAlt className="icon" />
                      <span>{tour.destination}</span>
                    </div>
                  </div>

                  <div className="price-section">
                    <div className="original-price">
                      ₹{tour.originalPrice?.toLocaleString('en-IN') || "0"}
                    </div>
                  </div>

                  <div className="highlights">
                    <h4>Tour Description:</h4>
                    <p>{tour.description}</p>
                  </div>

                  <div className="card-footer">
                    <button
                      className="details-btn"
                      onClick={() => handleDetailsClick(tour)}
                    >
                      View Details <FiChevronRight className="arrow-icon" />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {showModal && selectedTour && (
          <div className="modal-overlay">
            <div className="modal-container" ref={modalRef}>
              <button className="close-modal" onClick={closeModal}>
                <FaTimes />
              </button>

              <div className="modal-header">
                <div className="modal-image-container">
                  <img
                    src={
                      selectedTour.image ||
                      "https://via.placeholder.com/800x400"
                    }
                    alt={selectedTour.title}
                  />
                </div>
                <div className="modal-title">
                  <h2>{selectedTour.title}</h2>
                  <div className="tour-meta">
                    <span>
                      <FaMapMarkerAlt /> {selectedTour.destination}
                    </span>
                    <span>
                      <FaCalendarAlt /> {selectedTour.days} Days /{" "}
                      {selectedTour.nights} Nights
                    </span>
                  </div>
                </div>
              </div>

              <div className="modal-content">
                <div className="price-section">
                  <div className="discounted-price">
                    <span>Package Price: {selectedTour.price}</span>
                  
                  </div>
              
                </div>

                <div className="section">
                  <h3>Package Description</h3>
                  <p>{selectedTour.description}</p>
                </div>

                {selectedTour.itinerary &&
                  selectedTour.itinerary.length > 0 && (
                    <div className="section">
                      <h3>Tour Itinerary</h3>
                      <div className="itinerary-list">
                        {selectedTour.itinerary.map((day, index) => (
                          <div key={index} className="itinerary-day">
                            <h4>
                              Day {index + 1}:{" "}
                              {typeof day === "object"
                                ? day.title
                                : "Day Activities"}
                            </h4>
                            <p>
                              {typeof day === "object"
                                ? day.description || day.title
                                : day}
                            </p>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                <div className="features-grid">
                  <div className="features-section">
                    <h3>What's Included</h3>
                    <ul>
                      {selectedTour.includes &&
                      selectedTour.includes.length > 0 ? (
                        selectedTour.includes.map((item, index) => (
                          <li key={index}>
                            <FaStar className="icon" /> {item}
                          </li>
                        ))
                      ) : (
                        <>
                          <li>
                            <FaPlane className="icon" /> Flights
                          </li>
                          <li>
                            <FaHotel className="icon" /> Hotel Accommodation
                          </li>
                          <li>
                            <FaUtensils className="icon" /> Daily Breakfast
                          </li>
                          <li>
                            <FaBus className="icon" /> All Transfers
                          </li>
                          <li>
                            <FaMonument className="icon" /> Sightseeing Tours
                          </li>
                        </>
                      )}
                    </ul>
                  </div>

                  <div className="features-section">
                    <h3>What's Not Included</h3>
                    <ul>
                      {selectedTour.excludes &&
                      selectedTour.excludes.length > 0 ? (
                        selectedTour.excludes.map((item, index) => (
                          <li key={index}>
                            <FaStar className="icon" /> {item}
                          </li>
                        ))
                      ) : (
                        <>
                          <li>Personal Expenses</li>
                          <li>Travel Insurance</li>
                          <li>Visa Fees</li>
                          <li>Lunch & Dinner</li>
                          <li>Optional Activities</li>
                        </>
                      )}
                    </ul>
                  </div>
                </div>

                <div className="modal-actions">
                  <button className="pdf-btn" onClick={generatePDF}>
                    <FaFilePdf /> Download PDF
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer1 />
      <style jsx>{`
        :root {
          --primary-color: #2563eb;
          --primary-dark: #1e40af;
          --secondary-color: #f59e0b;
          --secondary-dark: #d97706;
          --accent-color: #4f46e5;
          --light-bg: #f8fafc;
          --dark-text: #1e293b;
          --light-text: #ffffff;
          --gray-text: #64748b;
          --card-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
            0 4px 6px -2px rgba(0, 0, 0, 0.05);
          --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          --border-radius: 12px;
        }

        .departure-page {
          max-width: 1400px;
          margin: 0 auto;
          padding: 0 20px 60px;
          font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
          background-color: var(--light-bg);
        }

        .page-header {
          text-align: center;
          margin-bottom: 60px;
          padding: 60px 0 40px;
          position: relative;
          background: linear-gradient(135deg, #f0f4ff 0%, #f8fafc 100%);
          border-radius: 0 0 var(--border-radius) var(--border-radius);
          overflow: hidden;
        }

        .page-header::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(
            90deg,
            var(--primary-color),
            var(--secondary-color)
          );
        }

        .header-content {
          max-width: 800px;
          margin: 0 auto;
          position: relative;
        }

        .page-header h1 {
          font-size: 3rem;
          font-weight: 800;
          color: var(--dark-text);
          margin-bottom: 16px;
          line-height: 1.2;
        }

        .page-header h1 span {
          color: var(--primary-color);
          position: relative;
        }

        .page-header h1 span::after {
          content: "";
          position: absolute;
          bottom: 5px;
          left: 0;
          right: 0;
          height: 8px;
          background-color: rgba(37, 99, 235, 0.2);
          z-index: -1;
        }

        .page-header p {
          font-size: 1.1rem;
          color: var(--gray-text);
          max-width: 600px;
          margin: 0 auto 24px;
          line-height: 1.6;
        }

        .header-decoration {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          margin-top: 24px;
        }

        .decoration-line {
          width: 40px;
          height: 2px;
          background-color: var(--primary-color);
          opacity: 0.5;
        }

        .decoration-dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: var(--secondary-color);
        }

        .tour-grid-container {
          padding: 0 20px;
        }

        .tour-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
          gap: 30px;
          padding: 0;
        }

        .tour-card {
          background: white;
          border-radius: var(--border-radius);
          overflow: hidden;
          box-shadow: var(--card-shadow);
          transition: var(--transition);
          position: relative;
          display: flex;
          flex-direction: column;
        }

        .tour-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
            0 10px 10px -5px rgba(0, 0, 0, 0.04);
        }

        .tour-card.best-selling {
          border-top: 4px solid var(--secondary-color);
        }

        .best-seller-badge {
          position: absolute;
          top: 20px;
          right: -8px;
          z-index: 2;
          display: flex;
          align-items: center;
        }

        .best-seller-badge span {
          background-color: var(--secondary-color);
          color: white;
          padding: 6px 16px;
          font-size: 0.75rem;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.05em;
        }

        .badge-tail {
          width: 0;
          height: 0;
          border-top: 8px solid var(--secondary-dark);
          border-left: 8px solid transparent;
        }

        .card-image-container {
          position: relative;
          height: 220px;
          overflow: hidden;
        }

        .card-image-container img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }

        .tour-card:hover .card-image-container img {
          transform: scale(1.05);
        }

        .image-overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
          padding: 16px;
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
        }

        .tour-duration {
          background: rgba(0, 0, 0, 0.7);
          color: white;
          padding: 4px 12px;
          border-radius: 20px;
          font-size: 0.8rem;
          font-weight: 500;
        }

        .rating-badge {
          display: flex;
          align-items: center;
          background-color: rgba(255, 255, 255, 0.9);
          padding: 4px 8px;
          border-radius: 20px;
          color: var(--dark-text);
          font-size: 0.8rem;
          font-weight: 600;
        }

        .rating-badge .star-icon {
          color: var(--secondary-color);
          margin-right: 4px;
          font-size: 0.7rem;
        }

        .card-content {
          padding: 24px;
          flex: 1;
          display: flex;
          flex-direction: column;
        }

        .tour-header {
          margin-bottom: 16px;
        }

        .tour-header h3 {
          font-size: 1.25rem;
          font-weight: 700;
          color: var(--dark-text);
          margin-bottom: 8px;
          line-height: 1.3;
        }

        .tour-destination {
          display: flex;
          align-items: center;
          color: var(--gray-text);
          font-size: 0.9rem;
        }

        .tour-destination .icon {
          margin-right: 6px;
          color: var(--primary-color);
          font-size: 0.8rem;
        }

        .price-section {
          margin: 16px 0;
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        .discounted-price {
          font-size: 1.5rem;
          font-weight: 800;
          color: var(--primary-color);
          display: flex;
          align-items: flex-end;
          gap: 8px;
        }

        .price-label {
          font-size: 0.8rem;
          color: var(--gray-text);
          font-weight: 400;
          margin-bottom: 2px;
        }

        .original-price {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 0.9rem;
        }

        .original-price span:first-child {
          text-decoration: line-through;
          color: var(--gray-text);
        }

        .discount-badge {
          background-color: var(--secondary-color);
          color: white;
          font-size: 0.7rem;
          font-weight: 600;
          padding: 2px 8px;
          border-radius: 4px;
        }

        .highlights {
          margin: 16px 0;
          flex: 1;
        }

        .highlights h4 {
          font-size: 0.9rem;
          color: var(--dark-text);
          margin-bottom: 8px;
          font-weight: 600;
        }

        .highlights p {
          font-size: 0.9rem;
          color: var(--gray-text);
          line-height: 1.5;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .card-footer {
          margin-top: auto;
        }

        .details-btn {
          width: 100%;
          padding: 12px;
          background-color: var(--primary-color);
          color: white;
          border: none;
          border-radius: 6px;
          font-size: 0.9rem;
          font-weight: 600;
          cursor: pointer;
          transition: var(--transition);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }

        .details-btn:hover {
          background-color: var(--primary-dark);
          transform: translateY(-2px);
        }

        .details-btn .arrow-icon {
          transition: transform 0.3s ease;
        }

        .details-btn:hover .arrow-icon {
          transform: translateX(3px);
        }

        /* Modal Styles */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.7);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          padding: 20px;
          overflow-y: auto;
        }

        .modal-container {
          background: white;
          border-radius: 10px;
          max-width: 900px;
          width: 100%;
          max-height: 90vh;
          overflow-y: auto;
          box-shadow: 0 5px 30px rgba(0, 0, 0, 0.3);
          position: relative;
          animation: modalFadeIn 0.3s ease;
        }

        @keyframes modalFadeIn {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .close-modal {
          position: absolute;
          top: 15px;
          right: 15px;
          background: none;
          border: none;
          font-size: 1.5rem;
          color: #777;
          cursor: pointer;
          z-index: 10;
          transition: var(--transition);
        }

        .close-modal:hover {
          color: var(--primary-color);
          transform: rotate(90deg);
        }

        .modal-header {
          position: relative;
        }

        .modal-image-container {
          height: 300px;
          overflow: hidden;
        }

        .modal-image-container img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .modal-title {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          padding: 20px;
          background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
          color: white;
        }

        .modal-title h2 {
          margin: 0;
          font-size: 1.8rem;
          color: white;
        }

        .tour-meta {
          display: flex;
          gap: 20px;
          margin-top: 10px;
          font-size: 0.9rem;
        }

        .tour-meta span {
          display: flex;
          align-items: center;
          gap: 5px;
        }

        .modal-content {
          padding: 30px;
        }

        .price-section {
          background: #f8f9fa;
          padding: 20px;
          border-radius: 8px;
          margin-bottom: 30px;
          text-align: center;
        }

        .original-price {
          color: #777;
          margin-bottom: 5px;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 10px;
        }

        .discount-badge {
          background: var(--secondary-color);
          color: white;
          padding: 3px 10px;
          border-radius: 20px;
          font-size: 0.8rem;
        }

        .discounted-price {
          font-size: 1.8rem;
          font-weight: bold;
          color: var(--primary-color);
          margin-top: 5px;
        }

        .price-label {
          font-size: 0.9rem;
          color: #777;
          margin-left: 5px;
          font-weight: normal;
        }

        .section {
          margin-bottom: 30px;
        }

        .section h3 {
          color: var(--primary-color);
          margin-bottom: 15px;
          padding-bottom: 5px;
          border-bottom: 2px solid #eee;
        }

        .itinerary-list {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .itinerary-day {
          background: #f8f9fa;
          padding: 15px;
          border-radius: 8px;
        }

        .itinerary-day h4 {
          color: var(--primary-color);
          margin-bottom: 10px;
        }

        .itinerary-day p {
          margin: 0;
        }

        .features-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 30px;
          margin: 30px 0;
        }

        .features-section h3 {
          color: var(--primary-color);
          margin-bottom: 15px;
        }

        .features-section ul {
          list-style: none;
          padding: 0;
        }

        .features-section li {
          margin-bottom: 10px;
          display: flex;
          align-items: flex-start;
          gap: 8px;
        }

        .features-section li .icon {
          color: var(--secondary-color);
          margin-top: 3px;
          flex-shrink: 0;
        }

        .modal-actions {
          display: flex;
          justify-content: center;
          margin-top: 30px;
        }

        .pdf-btn {
          background-color: var(--primary-color);
          color: white;
          border: none;
          padding: 12px 24px;
          border-radius: 6px;
          font-size: 1rem;
          font-weight: 600;
          cursor: pointer;
          transition: var(--transition);
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .pdf-btn:hover {
          background-color: var(--primary-dark);
          transform: translateY(-2px);
        }

        /* Loading and Error States */
        .loading-container,
        .error-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          min-height: 60vh;
          text-align: center;
        }

        .spinner {
          width: 50px;
          height: 50px;
          border: 5px solid rgba(37, 99, 235, 0.2);
          border-radius: 50%;
          border-top-color: var(--primary-color);
          animation: spin 1s ease-in-out infinite;
          margin-bottom: 20px;
        }

        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }

        .loading-container p {
          font-size: 1.2rem;
          color: var(--gray-text);
        }

        .error-container p {
          font-size: 1.2rem;
          color: #dc2626;
          margin-bottom: 20px;
        }

        .error-container button {
          background-color: var(--primary-color);
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 6px;
          font-size: 1rem;
          cursor: pointer;
          transition: var(--transition);
        }

        .error-container button:hover {
          background-color: var(--primary-dark);
        }

        /* Responsive Styles */
        @media (max-width: 1024px) {
          .tour-grid {
            grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
          }

          .modal-container {
            max-width: 90%;
          }
        }

        @media (max-width: 768px) {
          .page-header h1 {
            font-size: 2.2rem;
          }

          .features-grid {
            grid-template-columns: 1fr;
          }

          .modal-image-container {
            height: 200px;
          }

          .modal-title h2 {
            font-size: 1.5rem;
          }
        }

        @media (max-width: 480px) {
          .departure-page {
            padding: 0 15px 40px;
          }

          .page-header {
            padding: 40px 0 30px;
          }

          .page-header h1 {
            font-size: 1.8rem;
          }

          .page-header p {
            font-size: 1rem;
          }

          .tour-grid {
            grid-template-columns: 1fr;
            gap: 20px;
          }

          .card-image-container {
            height: 180px;
          }

          .modal-content {
            padding: 20px;
          }

          .tour-meta {
            flex-direction: column;
            gap: 5px;
          }
        }
      `}</style>
    </>
  );
};

export default DeparturePage;
